import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/person/person-title.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d9c014ee"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "popup-wrap"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "wrap-title",
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1);
});
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "popup-mask"
  }, null, -1);
});
export default {
  __name: 'tipsPopup',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "popup-close",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.$emit('close');
        })
      }), _hoisted_2, _createElementVNode("div", {
        innerHTML: __props.content,
        class: "tips-popup-content"
      }, null, 8, _hoisted_3)]), _hoisted_4], 64);
    };
  }
};